import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const DEFAULT_TRANSLATION_KEYS = {
  en: {
    "global.text.internetDisconnectedTitle": "Connection Error",
    "global.text.internetDisconnected":
      "Please check your internet connection.",
    "global.text.somethingWentWrongDescription":
      '<p>Oops, something went wrong. Please try again later. If this doesn\'t get resolved soon, contact <a href="mailto:support@vdbapp.com">support@vdbapp.com</a></p>',
  },
};

export const translation = createSlice({
  name: "translation",
  initialState: DEFAULT_TRANSLATION_KEYS,
  reducers: {
    setTranslationKeys: (state, action) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(),
      };
    },
  },
});

export const { setTranslationKeys } = translation.actions;

export const useTranslationKeys = () =>
  useSelector((state: any) => state.translation);

export default translation.reducer;
